exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-baby-2-js": () => import("./../../../src/pages/baby2.js" /* webpackChunkName: "component---src-pages-baby-2-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pelican-js": () => import("./../../../src/pages/pelican.js" /* webpackChunkName: "component---src-pages-pelican-js" */)
}

